import { useEffect, useState } from 'react';

function durationForValue(value: number): number {
  const abs = Math.abs(value);
  if (abs > 1_000_000) return 3000;
  if (abs > 100_000) return 2500;
  if (abs > 10_000) return 2000;
  if (abs > 1_000) return 1500;
  return 1000;
}

/** Count-up animation matching Zero dashboard StatCard behavior. */
export function useAnimatedNumber(value: number): number {
  const [animatedValue, setAnimatedValue] = useState(0);

  useEffect(() => {
    if (value === 0) {
      setAnimatedValue(0);
      return;
    }

    const duration = durationForValue(value);
    const steps = 60;
    const increment = value / steps;
    const stepTime = duration / steps;

    let currentValue = 0;
    setAnimatedValue(0);

    const timer = setInterval(() => {
      currentValue += increment;
      if (currentValue >= value) {
        setAnimatedValue(value);
        clearInterval(timer);
      } else {
        setAnimatedValue(currentValue);
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [value]);

  return animatedValue;
}
